export function redirected(path: string) {
  const originUrl = window.location.origin;
  window.location.href = originUrl + path;
}